/* eslint-disable */

import React, { Component } from "react"

import {
    usRegions,
} from 'shared/imports/regionConstants'
import { federalMapConfig } from "search-new/components/Visualization/VisualizationWrappers/MapConfigs"

import {
    genericBarPieScene,
    genericLineScene,
    createUSMapScene,
} from "search-new/containers/Visualization/VisualizationScene/VisualizationScenes"


import {
    ReceiptsPartiesFilter,
    ReceiptsDateBeforeFilter,
    ReceiptsDateAfterFilter,
    ReceiptsSupportedRegionsFilter,
    ReceiptsContactsFilter,
    ReceiptsCandidatesFilter,
    ReceiptsCommitteesFilterInternal
} from "shared/search/containers/Filter/ReceiptsFilter"

/* *****************************************************************
* BAR / PIE COMBO GRAPHS
******************************************************************* */
export class ReceiptsBarPieScene extends Component {
    static defaultProps = {
        uniqueVizSceneId: 'receiptsOfficialsBarPieScene',
        filterId: ReceiptsCandidatesFilter.defaultProps.uniqueFilterId,
        variableRequestKey: 'committeeOfficials',
        label: "Officials",
        icon: "fa-user",
        regions: usRegions,
        sidebarTableLabel: "Officials",
    }

    render() {
        return genericBarPieScene(this.props)
    }
}

export class ReceiptsCommitteesBarPieScene extends Component {
    static defaultProps = {
        uniqueVizSceneId: 'receiptsCommitteesBarPieScene',
        filterId: ReceiptsCommitteesFilterInternal.defaultProps.uniqueFilterId,
        variableRequestKey: 'recipientCommitteesChart',
        label: "Political Committees",
        icon: "fa-gavel",
        regions: usRegions,
        sidebarTableLabel: "Political Committees",
    }

    render() {
        return genericBarPieScene(this.props)
    }
}


export class ReceiptsPartyBarPieScene extends Component {
    static defaultProps = {
        uniqueVizSceneId: 'receiptsPartyBarPieScene',
        filterId: ReceiptsPartiesFilter.defaultProps.uniqueFilterId,
        variableRequestKey: 'recipientCommitteePartyChart',
        label: "Party",
        icon: "fa-check-square-o",
        regions: usRegions,
        sidebarTableLabel: "Party",
    }

    render() {
        return genericBarPieScene(this.props)
    }
}

export class ReceiptsContactsBarPieScene extends Component {
    static defaultProps = {
        uniqueVizSceneId: 'receiptsContactsBarPieScene',
        filterId: ReceiptsContactsFilter.defaultProps.uniqueFilterId,
        variableRequestKey: 'committeeContacts',
        label: "Contacts",
        icon: "fa-child",
        regions: usRegions,
        sidebarTableLabel: "Contacts",
    }

    render() {
        return genericBarPieScene(this.props)
    }
}


/* *****************************************************************
* LINE GRAPH (TREND)
******************************************************************* */
export class ReceiptsTrendsScene extends Component {
    static defaultProps = {
        uniqueVizSceneId: 'receiptsTrendsScene',
        dateStartId: ReceiptsDateAfterFilter.defaultProps.uniqueFilterId,
        dateEndId: ReceiptsDateBeforeFilter.defaultProps.uniqueFilterId,
        variableRequestKey: 'receiptsTrendsChart',
        label: "Trends",
        icon: "fa-line-chart",
    }

    render() {
        return genericLineScene(this.props)
    }
}


/* *****************************************************************
* MAPS
******************************************************************* */
export const ReceiptsMapScene = createUSMapScene({
    uniqueFilterId: ReceiptsSupportedRegionsFilter.defaultProps.uniqueFilterId,
    configs: {
        ...federalMapConfig,
        formatGeoData: (data) => {
            // we're indexing everything in the map based on state Region enums!
            const getRegionEnumFromFips = fips =>
                DjangIO.app.models.Region.items()
                    .filter(item => item.is_state_region)
                    .find(item => item.fips_code === fips)

            // topojson is attached to the window in frontend/index.js, we'll just
            // accept that.
            // eslint-disable-next-line no-undef
            const formattedStateData = topojson.feature(data, data.objects.states).features
                .map(region => {
                    const regionEnum = getRegionEnumFromFips(region.id)
                    return {
                        ...region,
                        enumId: regionEnum.value,
                        resourceId: regionEnum.abbrev.toUpperCase(), // patched resourceId to use state abbr
                        short_display: regionEnum.abbrev.toUpperCase(),
                        long_display: regionEnum.region_name,
                    }
                })

            return formattedStateData
        }
    },
})
